import { IAPIRoutes } from "../../../../config";

export type IEhrRecordsRepository = ReturnType<
  typeof EhrRecordsRepositoryFactory
>;

export const EhrRecordsRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getEhrMedicationsAPI: IGetEhrMedicationsAPI = async (payload) => {
    const url = APIRoutes.apiGetEhrMedications
      .replace("{clinic_id}", payload.clinic_id.toString())
      .replace("{patient_id}", payload.patient_id.toString());

    const params: Record<string, string> = {};
    if (payload.status) {
      params.status = payload.status;
    }
    if (typeof payload.limit === "number") {
      params.limit = payload.limit.toString();
    }
    if (typeof payload.offset === "number") {
      params.offset = payload.offset.toString();
    }

    return GET(url, params, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  const getEhrNutritionAPI: IGetEhrNutritionAPI = async (payload) => {
    const url = APIRoutes.apiGetEhrNutrition
      .replace("{clinic_id}", payload.clinic_id.toString())
      .replace("{patient_id}", payload.patient_id.toString());

    const params: Record<string, string> = {};
    if (payload.status) {
      params.status = payload.status;
    }
    if (typeof payload.limit === "number") {
      params.limit = payload.limit.toString();
    }
    if (typeof payload.offset === "number") {
      params.offset = payload.offset.toString();
    }

    return GET(url, params, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  const getEhrAssessmentsAPI: IGetEhrAssessmentsAPI = async (payload) => {
    const url = APIRoutes.apiGetEhrAssessments
      .replace("{clinic_id}", payload.clinic_id.toString())
      .replace("{patient_id}", payload.patient_id.toString());

    const params: Record<string, string> = {};
    if (payload.assessment_status) {
      params.assessment_status = payload.assessment_status;
    }
    if (payload.assessment_type) {
      params.assessment_type = payload.assessment_type;
    }
    if (typeof payload.limit === "number") {
      params.limit = payload.limit.toString();
    }
    if (typeof payload.offset === "number") {
      params.offset = payload.offset.toString();
    }

    return GET(url, params, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  const getEhrAllergiesAPI: IGetEhrAllergiesAPI = async (payload) => {
    const url = APIRoutes.apiGetEhrAllergies
      .replace("{clinic_id}", payload.clinic_id.toString())
      .replace("{patient_id}", payload.patient_id.toString());

    const params: Record<string, string> = {};
    if (typeof payload.status === "number") {
      params.status = payload.status.toString();
    }
    if (payload.category) {
      params.category = payload.category;
    }
    if (payload.clinical_status) {
      params.clinical_status = payload.clinical_status;
    }
    if (typeof payload.limit === "number") {
      params.limit = payload.limit.toString();
    }
    if (typeof payload.offset === "number") {
      params.offset = payload.offset.toString();
    }

    return GET(url, params, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  const getEhrLabsAPI: IGetEhrLabsAPI = async (payload) => {
    const url = APIRoutes.apiGetEhrLabs
      .replace("{clinic_id}", payload.clinic_id.toString())
      .replace("{patient_id}", payload.patient_id.toString());

    const params: Record<string, string> = {};
    if (payload.report_type) {
      params.report_type = payload.report_type;
    }
    if (payload.report_status) {
      params.report_status = payload.report_status;
    }
    if (typeof payload.limit === "number") {
      params.limit = payload.limit.toString();
    }
    if (typeof payload.offset === "number") {
      params.offset = payload.offset.toString();
    }

    return GET(url, params, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  return {
    getEhrMedicationsAPI,
    getEhrNutritionAPI,
    getEhrAssessmentsAPI,
    getEhrAllergiesAPI,
    getEhrLabsAPI,
  };
};
